// Реквизиты продавца — показываются в оферте и условиях использования.
const seller = {
  name: "Индивидуальный предприниматель Карпенко Денис Константинович",
  short: "ИП Карпенко Д. К.",
  genitive: "Индивидуального предпринимателя Карпенко Дениса Константиновича",
  inn: "246606308733",
  ogrnip: "325246800041725",
  address: "660049, Россия, Красноярский край, г. Красноярск, ул. Дубровинского",
  email: "sprosi.link@gmail.com",
  telegram: "https://t.me/sprosi_link_bot",
  tax: "НДС не облагается в связи с применением специального налогового режима",
  updated: "20 сентября 2026 г.",
};

export default seller;
